import * as React from 'react';
import {IBaseView} from "../../_base/base-view";
import {inject, observer} from "mobx-react";
import {UsergroupRight} from "../../../models/rights/enum-usergrouprights";
import {TableGrid} from "../../_base/styled/table-grid";
import {TableLayout} from "../../_base/styled/layout/table-layout";

@inject('rootStore')
@observer
export class AuditTemplateTableView extends React.Component<IBaseView, {}> {

    render() {
        const {rootStore: {auditTemplateStore: {ds}, authStore: {hasUserRight}}} = this.props;
        return (
            <TableLayout>
                <TableGrid
                    id="audittemplate"
                    icon="eye"
                    title='AUDIT_TEMPLATES'
                    ds={ds}
                    singleRouteName='audittemplate'
                    hideInsert={!hasUserRight(UsergroupRight.UR_AUDIT_TEMPLATE_INSERT)}
                    hideDelete={!hasUserRight(UsergroupRight.UR_AUDIT_TEMPLATE_DELETE)}
                />
            </TableLayout>
        )
    }
}